import React, { Component } from 'react';
import './cart.scss';
import { getCart, clearLocalStorage } from '../util/localStorage';
import CartProductBox from './CartProductBox';
import { Link } from 'react-router-dom';
import emptyBox from '../../images/my_cart/box.png';
import SelectCurrency from '../util/SelectCurrency';
import { FaCheck } from 'react-icons/fa'
import paypalPaymentMethods from '../../images/products/PayPal-payment.png';
import ReactLoading from 'react-loading';
import { Helmet } from 'react-helmet';
import { db } from '../../app-firebase/firebase';
import database from '../../db/db.json';

export class Cart extends Component {

   constructor(props) {
      super(props);

      this.state = {
         productsList: getCart(),
         subtotal: 1,
         paidFor: false,
         loaded: false,
         processStep: 2,
         loadingPaypalButton: true,
         downloads: Object.values(database.downloads),
         cartDownloads: []
      }
      this.insertPaypalButton = this.insertPaypalButton.bind(this);
      this.updateProductsList = this.updateProductsList.bind(this);
      this.handleChangeProcessStep = this.handleChangeProcessStep.bind(this);
      this.setPaymentDetails = this.setPaymentDetails.bind(this);

      this.nameGiven = 'Customer';
      this.renderButton = null;
   }

   componentDidMount() {
      if (this.state.processStep !== 3 && getCart().length) {
         this.insertPaypalButton();
      }
      if (!getCart().length) {
         document.getElementById('loading-button').style.display = 'none';
         document.getElementsByClassName('paypal-button')[0].style.display = 'none';
      }

      // Get downloads instance of database and store in the state
      // db.ref('downloads').on('value', snap => {
      //    this.setState({
      //       downloads: Object.values(snap.val())
      //    });
      // })


      // Check for download products in cart. Assign them to the state
      // in order to send the links after purchase has been complete
      const dlIds = [];
      this.state.productsList.forEach(val => {
         if (!val.weight) {
            if (!dlIds.includes(val.ipNumber)) dlIds.push(val.ipNumber)
         }
      });
      if (JSON.stringify(dlIds) !== JSON.stringify(this.state.cartDownloads)) {
         this.setState({
            cartDownloads: dlIds
         });
      }

   }

   componentDidUpdate() {
      clearTimeout(this.renderButton);
      if (this.state.processStep !== 3 && getCart().length) {
         this.insertPaypalButton();
         document.getElementById('loading-button').style.display = 'flex';
      }
      if (!this.state.productsList.length && this.state.processStep !== 2) {
         this.setState({
            processStep: 2
         });
      }
      
      if (!getCart().length) {
         document.getElementById('loading-button').style.display = 'none';
         document.getElementsByClassName('paypal-button')[0].style.display = 'none';
      }

      // Check for download products in cart. Assign them to the state
      // in order to send the links after purchase has been complete
      const dlIds = [];
      this.state.productsList.forEach(val => {
         if (!val.weight && !dlIds.includes(val.ipNumber)) {
            dlIds.push(val.ipNumber)
         }
      });
      if (JSON.stringify(dlIds) !== JSON.stringify(this.state.cartDownloads)) {
         this.setState({
            cartDownloads: dlIds
         });
      }
   }

   componentWillUnmount() {
      clearTimeout(this.renderButton);
      this.props.updateCartStorage();
      db.goOffline();
   }

   // React App
   /**
    * This is the method responsible for rendering the PayPal button.
    * It is called once the user is in the cart page and clicks on the button written "Proceed to checkout"
    * 
    */
   insertPaypalButton() {
      // gets the element where the button will be inserted
      // it exists in the index.html, it is an empty <div>
      document.querySelector('.paypal-button-script').innerHTML = '';
      
      // creates the script tag with the paypal SDK and the live app client ID.
      // also informs the currency currently selected by user. We work with both USD and CAD
      const script = document.createElement('script');
      script.src = 'https://www.paypal.com/sdk/js?client-id=AczPdhq1_e3XoJNbwzTywj3iYey3rnrNC3cNQqMndq68LAaaCo8Qo6Bca0EU0nb75bxcaJQSnqb1Kt7_&currency=' + this.props.currency;
      
      // once the page is loaded the loaded state is set to true.
      // before the page is fully loaded the button will not be rendered
      script.addEventListener('load', () => {
         if (!this.state.loaded) {
            this.setState({ loaded: true });
         }
      });

      // the script is put inside the empty <div>
      document.querySelector('.paypal-button-script').appendChild(script);

      // if page is loaded this is gonna work on the rendering of the paypal button
      if (this.state.loaded) {
         // the following methods just return values as described by the own name of the variables.
         const totalPrice = this.getTotal();
         const subtotal = this.getSubtotal();
         const tax = this.getGST();
         const shipping = this.getShipping();

         // This is the constant that receives all the item objects within an array
         const items = this.getCartList().map(item => {
            return {
               name: item.product.title,
               unit_amount: {
                  currency_code: this.props.currency,
                  value: this.props.currency === 'USD' ? item.product.priceUsd.toFixed(2) : item.product.priceCad.toFixed(2) 
               },
               quantity: item.qty.toString(),
               sku: item.product.ipNumber
            };
         });


         // the rendering of the PayPal button starts here
         this.renderButton = setTimeout(() => {
            document.getElementById('loading-button').style.display = 'none';
            try {
               window.paypal.Buttons({
                  createOrder: (data, actions) => {
                     
                     return actions.order.create({
                        purchase_units: [{
                           description: 'Inheritance Publications Products',
                           amount: {
                              currency_code: this.props.currency,
                              value: totalPrice.toFixed(2),
                              breakdown: {
                                 item_total: {
                                    currency_code: this.props.currency,
                                    value: subtotal.toFixed(2)
                                 },
                                 shipping: {
                                    currency_code: this.props.currency,
                                    value: shipping.toFixed(2)
                                 },
                                 tax_total: {
                                    currency_code: this.props.currency,
                                    value: tax.toFixed(2)
                                 }
                              }
                           },
                           items,
                           payee: {
                              email_address: 'orders@inhpubl.net',
                              merchant_id: 'LBSALWFFQNRSN'
                           }
                        }]
                     });
                  },
                  onApprove: (data, actions) => {
                     return actions.order.capture().then(details => {
                        // This function shows a transaction success message to your buyer.
                        if (this.state.cartDownloads.length > 0) {
                           this.sendEmail(details.payer.name.given_name, details.payer.email_address)
                        }

                        // const customer = {
                        //    name: details.payer.name,
                        //    emailAdress: details.payer.email_address,
                        //    id: details.payer.payer_id
                        // }
                        // console.log('customer:', customer);

                        // const purchase = {
                        //    id: details.id,
                        //    customerName: details.payer.name.given_name,
                        //    customerId: details.payer.payer_id,
                        //    purchases: this.getCartList(),
                        //    shipping: shipping.toFixed(2),
                        //    subtotal: subtotal.toFixed(2),
                        //    tax: tax.toFixed(2),
                        //    totalPrice: totalPrice.toFixed(2),
                        //    date: Date.now()
                        // }
                        // console.log('purchase:', purchase);

                        // let isCustomerInDB = false;
                        // db.ref().child('customers').once('value', snap => {
                        //    if (snap.val()) {
                        //    const customers = Object.values(snap.val());
                        //       customers.forEach(cust  => {
                        //          if (cust.id === customer.id) isCustomerInDB = true;
                        //       });
                        //    }
                        //    if (!isCustomerInDB) {
                        //       db.ref().child('customer').child(customer.id).set(customer, error => {
                        //          if (error) console.error(error.message);
                        //          else console.log('Customer added in database with success');
                        //       })
                        //    }
                        // });

                        // db.ref().child('purchases').child(details.id).set(purchase, error => {
                        //    if (error) console.error(error.message);
                        //    else console.log('Purchase added to DB with success');
                        // });

                        alert('Transaction Approved.');
                        this.nameGiven = details.payer.name.given_name;
                        this.handleChangeProcessStep(3);
                     });
                  }
               }).render('.paypal-button');
            }
            catch(err) {
               console.error(err)
            }
            
         }, 2000);
      }
   }

   sendEmail(name, email) {
      let mediaProds = this.state.productsList.filter(prod => {
         if (this.state.cartDownloads.includes(prod.ipNumber)) {
            return true;
         }
         return false;
      });

      mediaProds = mediaProds.map(prod => {
         let obj = {};
         this.state.downloads.forEach(down => {
            if (down.ipNumber === prod.ipNumber) {
               obj = down;
            };
         });
         console.log(typeof obj.links);
         return {
            ...prod,
            links: obj.links
         }
      })
      if (!name) {
         console.log('mediaProds:', mediaProds);
         return;
      }
      let html = '';

      mediaProds.forEach(val => {
         console.log(typeof val.links);
         val.links.forEach((v, i) => {
            html += `<p><a href="${v.link}">Click here</a> to download ${v.legend}<br />`
         });
         html += '<br /><br />'
      })
      const template_params = {
         "client_email": email,
         "name": name,
         "html": html
      }
      
      var service_id = "default_service";
      var template_id = "products_purchased";
      window.emailjs.send(service_id, template_id, template_params);
   }

   setPaymentDetails(name) {
      this.nameGiven = name;
   }


   updateProductsList() {
      if (getCart) {
         this.setState( {
            productsList: getCart()
         });
      }
   }

   getSubtotal() {
      let subtotal = 0;
      if (this.state.productsList) {
         this.state.productsList.forEach(product => {
            subtotal += this.props.currency === 'CAD' ? product.priceCad : product.priceUsd;
         });
      }
      return Math.round(subtotal * 100) / 100;
   }

   getGST() {
      const gst = this.props.currency === 'USD' ? 0 : Math.round(this.getSubtotalPlusShipping() * 0.05 * 100) / 100;
      return gst;
   }

   getSubtotalPlusShipping() {
      return this.getSubtotal() + this.getShipping();
   }

   getShipping() {
      const searchDownloads = this.state.productsList.map(val => !val.weight);
      const onlyDownloads = !searchDownloads.includes(false);
      let amount = this.getSubtotal();
      let shipping = 0;
      if (amount !== 0) {
         shipping = this.props.currency === 'USD' ? 8 : 13;
      }
      if (onlyDownloads) shipping = 0;
      if (this.props.currency === 'USD' && amount !== 0 && amount > 250) {
         shipping = 0;
      } else if (this.props.currency === 'CAD' && amount !== 0 && amount > 350) {
         shipping = 0;
      }
      return shipping;
   }

   getTotal() {
      return this.getSubtotal() + this.getGST() + this.getShipping();
   }

   
   
   showProcess() {
      const regStyle = {
         color: '#aaa'
      }

      const highlightStyle = {
         color: 'white',
         fontWeight: 'bold',
         backgroundColor: '#118ab2'
      }

      return (
         <div className="process-step d-flex">
            {/* <p style={this.state.processStep === 1 ? highlightStyle : regStyle}>1. Manage Cart</p> */}
            <p style={this.state.processStep === 2 ? highlightStyle : regStyle}>1. Paypal payment</p>
            <p style={this.state.processStep === 3 ? highlightStyle : regStyle}>2. Confirmation</p>
         </div>
      )
   }


   handleChangeProcessStep(processStep) {
      if (this.state.processStep !== processStep) {
         this.setState({
            processStep
         }, () => {
            if (processStep === 3) {
               window.scroll(0,0)
            }
         });
      }
   }


   handleClearButton() {
      const confirm = window.confirm('Your cart will be emptied. Proceed?');
      if (confirm) {
         clearLocalStorage();
         this.updateProductsList();
         this.props.updateCartStorage();
      }
      
   }

   getCartList() {
      let cart = [];
      if (this.state.productsList) {
         this.state.productsList.forEach((product) => {
            if (cart.length === 0) {
               cart.push({
                  qty: 1,
                  product
               });
            } else {
               cart.some((p, i) => {
                  if (p.product.ipNumber === product.ipNumber) {
                     p.qty++;
                     return true;
                  }
                  else if (i === cart.length - 1) {
                     cart.push({
                        qty: 1,
                        product
                     })
                     return false;
                  }
                  else return false;
               });
            }
         });
      }
      return cart;
   }

   showCart(list) {
      return list.map((val, index) => {
         return (
            <div key={`${val.product.ipNumber}-${index}`}>
               <CartProductBox updateCartStorage={this.props.updateCartStorage} prod={val} updateProductsList={this.updateProductsList} currency={this.props.currency}/>
            </div>
         )
      });
   }

   showEmptyCart() {
      return (
         <div className="empty-cart d-flex align-items-center">
            <h3>Your cart is empty</h3>
            <Link to='/products'><p>Continue Shopping</p></Link>
            <img src={emptyBox} alt=""></img>
         </div>
      )
   }

   render() {
      const cartList = this.getCartList();
      cartList.sort((a, b) => {
         if (a.product.title > b.product.title) return 1;
         if (a.product.title < b.product.title) return -1;
         return 0;
      });

      const legend = (
         <div className="cart-list-legend d-flex">
            <div className="cl-legend-1">Item</div>
            <div className="cl-legend-2">Title</div>
            <div className="cl-legend-3">Price</div>
            <div className="cl-legend-4">Qty</div>
            <div className="cl-legend-5">Total</div>
         </div>
      )

      return (
         <div className="container-fluid justify-content-center">
            <Helmet>
               <title>Inheritance Publications::Cart - PayPal checkout</title>
               <meta name="keywords" content="books, historical books, reformed books, reformed books for children, fiction books, reformed church, historical fiction, historical fiction books, short stories, liturgy, reformed worship, 80 years war, 30 years war, world war 2, Bible books, Christian books, Christian literature, literature, Psalm CDs, Hymn CDs, DVDs, Music DVDs, audio books, sheet music, church sheet music, Dutch sheet music, Psalm sheet music, organ sheet music"/>
               <meta name="description" content="Inheritance Publications is a small company which was established to provide Biblical Reformed literature. We want to maintain the antithesis between right and wrong, between true and false christianity. It is also our desire to give God the honour and glory due to His Name because of His faithfulness. Remembering the great deeds of God in the history of His Church will always cause God's children to stand in awe of His Majesty. It is our aim to reach children, young adults, and adults with stories about the history of the Church. We also provide a wide selection of books on the doctrine of the Church. May God's Name be glorified and the readers edified by the reading of our books."/>
            </Helmet>
            <div className="row align-items-center about-us-heading cart-heading">
               <div className="about-us-shadow">
                  <h1>Cart</h1>
               </div>
            </div>

            {/* The most outer background */}
            <div className="row justify-content-center cart-layout">
               {/*  */}
               {this.state.processStep !== 3 ? 
                  <div className="cart-list">
                     {this.showProcess()}

                     {cartList.length !== 0 ? legend : null}

                     <div className="cart-list-content d-flex flex-column">
                        {
                           cartList.length !== 0 ? this.showCart(cartList) : this.showEmptyCart()
                        }
                     </div>
                  </div> 
                  :
                  <div className="payment-confirmation">
                     {this.showProcess()}
                     <div className="pc-details">
                        <h5><FaCheck /> Payment Completed!</h5>
                        <p>Thank you, {this.nameGiven}. Your new purchase is as follows...</p>
                        <div className="purchased-products">
                           <p>Products purchased:</p>
                           <ul>
                              {cartList.map(val => {
                                 return <li key={val.product.ipNumber}>{val.qty} x {val.product.title}</li>
                              })}
                           </ul>
                           {clearLocalStorage()}
                        </div>
                     </div>
                  </div>}


               <div className="order-summary">
                  {this.state.processStep !== 3 ? <SelectCurrency setCurrency={this.props.setCurrency} currency={this.props.currency} insertPaypalButton={this.insertPaypalButton}/> : null}

                  <div className="payment-methods">
                     <img src={paypalPaymentMethods} alt="PayPal Payment Methods" />
                  </div>

                  <div className="order-summary-box">
                     <h3>Order Summary</h3>
                     <div className="os-line"></div>
                     <div className="d-flex justify-content-between">
                        <p>Subtotal</p>
                        <p>$ {this.getSubtotal().toFixed(2)}</p>
                     </div>
                     <div className="d-flex justify-content-between">
                        <p>Shipping fee</p>
                        {  
                           // if shipping > 0 show FREE! message
                           // else show either FREE or 0.00 depending on the subtotal with taxes
                           this.getShipping() > 0 ?
                              <p>$ {this.getShipping().toFixed(2)}</p> :
                              this.getSubtotalPlusShipping() !== 0 ?
                                 <p style={{color:'green',fontWeight:'bold'}}>FREE!</p> :
                                 <p>$ 0.00</p>
                        }
                     </div>
                     {this.props.currency === 'USD' ?
                        null :
                        <div>
                           <div className="os-line"></div>
                           <div className="d-flex justify-content-between">
                              <p></p>
                              <p>$ {this.getSubtotalPlusShipping().toFixed(2)}</p>
                           </div>
                           <div className="d-flex justify-content-between">
                              <p>GST</p>
                              <p>$ {this.getGST().toFixed(2)}</p>
                           </div>
                        </div>
                     }
                     <div className="os-line os-line-bold"></div>
                     <div className="d-flex justify-content-between">
                        <p className="font-weight-bold">Total</p>
                     <p className="font-weight-bold">{this.props.currency}$ {this.getTotal().toFixed(2)}</p>
                     </div>

                     {/* {this.state.loadingPaypalButton ? */}
                        <div id="loading-button" className="">
                           <ReactLoading type="spin" color="#118ab2" />
                        </div>
                        {/* null
                     } */}

                     {this.getTotal() && this.state.processStep === 1 ? 
                           <button className="btn btn-info btn-block" onClick={() => this.handleChangeProcessStep(2)}>Proceed to checkout ({this.props.currency})</button> : 
                           null
                        }

                     <div className="paypal-button"></div>
                  </div>
                  {this.state.processStep !== 3 && getCart().length ? <button className="btn btn-info" onClick={() => this.handleClearButton()}>Clear cart</button> : null}
               </div>
               
               
            </div>
            {this.state.processStep === 3 ? <div className="text-center" style={{marginBottom: '2rem'}}>
                  <Link to="/products">Continue shopping</Link>
               </div> : null}
         </div>
      )
   }
}

export default Cart